import { render, staticRenderFns } from "./RecentTransactionMobile.vue?vue&type=template&id=9c555f88&scoped=true"
import script from "./RecentTransactionMobile.vue?vue&type=script&lang=js"
export * from "./RecentTransactionMobile.vue?vue&type=script&lang=js"
import style0 from "./RecentTransactionMobile.vue?vue&type=style&index=0&id=9c555f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c555f88",
  null
  
)

export default component.exports